import Model from '@/models/Model'

export default class GBarAuthorization extends Model {
  resource() {
    return 'bar_authorization'
  }
}